import { Input, SingleDatePicker } from '@salecycle/ui-component-library';
import { useStartDate } from '../hooks/useStartDate';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useStartTime } from '../hooks/useStartTime';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.designToken.spacing2};
`;

export const StartDateAndTimeControl = ({ splitTestId }: { splitTestId: string }) => {
  const { t } = useTranslation('campaigns');

  const { startDate, validation, ...startDateRest } = useStartDate({ splitTestId });
  const { startTime, onStartTimeChanged } = useStartTime({ splitTestId });

  return (
    <Container>
      <SingleDatePicker
        date={startDate}
        width="100px"
        label={t('onsite.editor.workflow.displayWebContentMessage.scheduling.startDate')}
        ariaLabel={t('onsite.editor.workflow.displayWebContentMessage.scheduling.startDateAria')}
        placeholder={t('onsite.editor.workflow.displayWebContentMessage.scheduling.startDatePlaceholder')}
        validationState={validation.passed ? '' : 'warning'}
        validationMessage={validation.passed ? undefined : validation.validationMessage}
        spacingBelow={false}
        {...startDateRest}
      />
      <Input
        value={startTime}
        onChange={onStartTimeChanged}
        ariaLabel={t('onsite.editor.workflow.displayWebContentMessage.scheduling.startTimeAria')}
        label={t('onsite.editor.workflow.displayWebContentMessage.scheduling.timeLabel')}
        type="time"
        style={{ width: 85, height: 50 }}
        spacingBelow={false}
      />
    </Container>
  );
};
